export default __webpack_public_path__ + "static/media/1257.fd87e258.JPG";